var tracker =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Tracker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	//import {GoogleRemarketingTag} from './google-remarketing-tag';
	
	
	var _datalayer = __webpack_require__(1044);
	
	var _admitadRetargeting = __webpack_require__(1045);
	
	var _admitadv = __webpack_require__(1046);
	
	var _retailrocket = __webpack_require__(132);
	
	var _vk = __webpack_require__(1047);
	
	var _whereElephantCpa = __webpack_require__(1048);
	
	var _yandexMetrika = __webpack_require__(136);
	
	var _vkAdsPixel = __webpack_require__(1049);
	
	var _advcake = __webpack_require__(1050);
	
	var _mindboxTraker = __webpack_require__(135);
	
	var _mindboxOperation = __webpack_require__(137);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import {Flocktory} from './flocktory';
	//import {MindboxTracker} from './mindbox';
	//import {MailRuTracker} from './mailru';
	//import {MailRuNewTracker} from './mailrunew';
	//import {GoogleRemarketingTracker} from './google-remarketing';
	//import {FacebookTracker} from './facebook';
	//import {Addigital} from './addigital';
	//import {AdSpireTracker} from './adspire';
	//import {AddigitalMgid} from './addigital-mgid';
	//import {LeelooTracker} from './leeloo';
	
	/**
	 * На бекенде инициализируется набор данных для аналитики. Будем использовать его в качестве контейнера для хранения
	 * данных и будем раздавать оттуда данные для аналитических сервисов и CPA партнеров
	 */
	var Tracker = exports.Tracker = function () {
	    function Tracker(data) {
	        _classCallCheck(this, Tracker);
	
	        this.data = data;
	        this.dataLayer = new _datalayer.DataLayerTracker(data);
	        this.admitAdRetargeting = _admitadRetargeting.AdmitAdRetargetingTracker;
	        //this.googleRemarketingTag = new GoogleRemarketingTag();
	        this.admitAdV2 = _admitadv.AdmitAdV2Tracker;
	        this.retailrocket = new _retailrocket.RetailRocket();
	        this.vk = new _vk.Vk();
	        this.whereElephantCpa = new _whereElephantCpa.WhereElephantCpa();
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	        this.vkAdsPixel = new _vkAdsPixel.VkAdsPixel();
	        this.advCake = new _advcake.AdvCake();
	        this.mindboxTracker = new _mindboxTraker.MindboxTracker();
	        this.mindboxOperation = new _mindboxOperation.MindboxOperation();
	
	        //this.facebook = new FacebookTracker();
	        //this.mindbox = new MindboxTracker();
	        //this.googleRemarketing = new GoogleRemarketingTracker();
	        //this.addigitalMgit = new AddigitalMgid();
	        //this.leelooTracker = new LeelooTracker();
	        //this.flocktory = new Flocktory();
	        //this.addigital = new Addigital();
	        //this.AdSpire = AdSpireTracker;
	        //this.mailru = new MailRuTracker();
	        //this.mailrunew = new MailRuNewTracker();
	        this.init();
	        this.backendPageViewed();
	    }
	
	    _createClass(Tracker, [{
	        key: 'init',
	        value: function init() {
	            this.admitAdRetargeting.init();
	            this.dataLayer.init();
	            this.admitAdV2.init();
	            this.whereElephantCpa.init();
	            this.vkAdsPixel.init();
	
	            //this.flocktory.init();
	            //this.mailru.init();
	            //this.mailrunew.init();
	        }
	    }, {
	        key: 'isUserAuthorized',
	        value: function isUserAuthorized() {
	            return this.data.user.authorized;
	        }
	    }, {
	        key: 'getCurrency',
	        value: function getCurrency() {
	            return this.data.currency;
	        }
	    }, {
	        key: 'clientTimeSite',
	        value: function clientTimeSite() {
	            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 190000;
	
	
	            var _self = this;
	
	            setTimeout(function () {
	                _self.yandexMetrika.timeClient();
	            }, time);
	        }
	    }, {
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            console.log('Current rout: ' + this.data.route);
	
	            try {
	                switch (this.data.route) {
	                    case 'index':
	                        this.indexPageViewed();
	                        break;
	                    case 'products':
	                        this.categoryPageViewed();
	                        break;
	                    case 'product':
	                        this.productPageViewed();
	                        break;
	                    case 'cart':
	                        this.basketPageViewed();
	                        break;
	                    case 'order':
	                        this.orderPageViewed();
	                        break;
	                    // это фейковый маршрут, но страница эта отдельная
	                    case 'order.thankyoupage':
	                        this.orderThankyouPageViewed();
	                        break;
	                    case 'order.paid':
	                        this.pageOrderPaid();
	                        break;
	                    // также является фейковым маршрутом
	                    case 'encyclopedia_pages.article':
	                        this.articlePageViewed();
	                        break;
	                    case '404':
	                        // не работает
	                        this.notFoundPageViewed();
	                        break;
	                    case 'search':
	                        this.searchPageViewed();
	                        break;
	                    case 'landing':
	                        this.landingPageViewed();
	                        break;
	                    default:
	                        this.otherPageViewed();
	                        break;
	                }
	            } catch (e) {
	                console.log(e);
	            }
	        }
	
	        /**
	         *  Страница Спасибо (после успешной оплаты или для наложенного платежа)
	         */
	
	    }, {
	        key: 'pageOrderPaid',
	        value: function pageOrderPaid() {}
	    }, {
	        key: 'page404',
	        value: function page404() {
	            this.yandexMetrika.notFountPage();
	        }
	    }, {
	        key: 'landingPageViewed',
	        value: function landingPageViewed() {
	            //this.leelooTracker.landingView();
	        }
	    }, {
	        key: 'registerPageViewed',
	        value: function registerPageViewed() {
	            this.admitAdRetargeting.registerPageView();
	
	            //this.mailru.otherPageView();
	            //this.mailrunew.otherPageView();
	            //this.facebook.lead();
	            //this.addigitalMgit.otherPageViewed();
	        }
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.admitAdRetargeting.indexPageView();
	            //this.googleRemarketingTag.indexPageView();
	            this.whereElephantCpa.indexPageView(this.data);
	            this.advCake.indexPageView(this.data);
	
	            //this.addigital.indexPageView();
	            //this.addigitalMgit.otherPageViewed();
	            //this.mailru.indexPageView();
	            //this.mailrunew.indexPageView();
	            //this.googleRemarketing.indexPageView();
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.admitAdRetargeting.categoryPageView(this.data.category);
	            this.dataLayer.categoryPageView(this.data.products);
	            this.retailrocket.viewContentCategory(this.data.category);
	            this.whereElephantCpa.categoryPageView(this.data);
	            this.advCake.categoryPageViewed(this.data);
	            this.mindboxTracker.categoryView(this.data.category);
	
	            //this.googleRemarketingTag.categoryPageView(this.data.products);
	            //this.addigital.categoryPageView();
	            //this.addigitalMgit.otherPageViewed();
	            //this.mailru.categoryPageView(this.data.products);
	            //this.mailrunew.categoryPageView(this.data.products);
	            //this.facebook.viewContentCategory(this.data.category);
	            //this.googleRemarketing.categoryPageView(this.data.products);
	            //this.mindbox.categoryPageView(this.data.category);
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.admitAdRetargeting.productPageView(this.data.product);
	            this.dataLayer.productPageView(this.data.product);
	            this.retailrocket.viewContentProduct(this.data.product);
	            this.vk.productPageView(this.data.product);
	            this.whereElephantCpa.productPageView(this.data);
	            this.vkAdsPixel.productPageView(this.data.product);
	            this.advCake.productPageView(this.data);
	            this.mindboxTracker.productView(this.data.product);
	
	            //this.googleRemarketingTag.productPageView(this.data.product);
	            //this.addigitalMgit.productPageViewed(this.data.product);
	            //this.leelooTracker.productView();
	            //this.addigital.productPageView(this.data.product);
	            //this.facebook.viewContentProduct(this.data.product);
	            //this.googleRemarketing.productPageView(this.data.product);
	            //this.mailru.productPageView(this.data.product);
	            //this.mailrunew.productPageView(this.data.product);
	            //this.mindbox.productPageView(this.data.product);
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            this.admitAdRetargeting.basketPageView(this.data.basket);
	            this.dataLayer.basketPageView(this.data.basket);
	            this.vk.basketPageView(this.data.basket);
	            this.whereElephantCpa.basketPageView(this.data);
	            this.advCake.basketPageViewed(this.data);
	
	            //this.googleRemarketingTag.basketPageView(this.data.basket);
	            //this.addigitalMgit.otherPageViewed();
	            //this.mailru.basketPageView(this.data.basket);
	            //this.mailrunew.basketPageView(this.data.basket);
	            //this.addigital.basketPageView(this.data.basket);
	            //this.googleRemarketing.basketPageView(this.data.basket);
	        }
	    }, {
	        key: 'productAddToFavorite',
	        value: function productAddToFavorite(params) {
	            this.dataLayer.push({ 'event': 'PMbtnWish' });
	            this.retailrocket.productAddToFavorite(params);
	            this.vkAdsPixel.productAddToFavorite(params.product);
	
	            //this.facebook.addToWishlist();
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.admitAdRetargeting.orderPageView();
	            this.dataLayer.orderPageView(this.data.basket);
	            this.advCake.pageOrderView(this.data);
	            this.retailrocket.setCustomer(this.data.user);
	
	            //this.mailru.orderPageView();
	            //this.mailrunew.orderPageView();
	            //this.addigital.orderPageView();
	            //this.addigitalMgit.otherPageViewed();
	            //this.facebook.initiateCheckout();
	            //this.googleRemarketing.orderPageView();
	        }
	
	        /**
	         *  Вот это по сути страница оплаты
	         */
	
	    }, {
	        key: 'orderThankyouPageViewed',
	        value: function orderThankyouPageViewed() {
	            this.admitAdRetargeting.orderThankyouPageView(this.data.order, this.data.basket);
	            this.dataLayer.orderThankyouPageView(this.data.order, this.data.basket);
	            this.admitAdV2.orderThankyouPageView(this.data.order, this.data.basket, this.data.user);
	            this.retailrocket.orderTransaction(this.data.order, this.data.basket, this.data.user);
	            this.vk.orderThankyouPageView(this.data.basket);
	            this.vkAdsPixel.orderThankyouPageView(this.data.basket);
	            this.advCake.orderThankyouPageViewed(this.data);
	            this.yandexMetrika.orderComplete();
	
	            //this.googleRemarketingTag.orderCreated(this.data.basket);
	            //this.flocktory.postcheckout(this.data.order, this.data.basket, this.data.user);
	            //this.addigitalMgit.orderThankyouPageView(this.data.basket);
	            //this.leelooTracker.orderThankyouPageView();
	            //this.AdSpire.orderThankyouPageView(this.data.order, this.data.basket, this.data.user);
	            //this.addigital.orderThankyouPageView(this.data.basket);
	            //this.mailru.orderThankyouPageView(this.data.basket);
	            //this.mailrunew.orderThankyouPageView(this.data.basket);
	
	            //this.facebook.purchase(this.data.order);
	            //this.facebook.leadOrder(this.data.order);
	            //this.googleRemarketing.orderThankyouPageView(this.data.basket);
	            //this.mindbox.orderCreated(this.data.order, this.data.basket, this.data.user);
	        }
	    }, {
	        key: 'articlePageViewed',
	        value: function articlePageViewed() {
	            //this.facebook.viewContent();
	            //this.addigitalMgit.otherPageViewed();
	        }
	    }, {
	        key: 'searchPageViewed',
	        value: function searchPageViewed() {
	            //this.googleRemarketingTag.searchPageView(this.data.products);
	
	            //this.mailru.searchPageView();
	            //this.mailrunew.searchPageView();
	            //this.facebook.search();
	            //this.addigital.searchPageView();
	            //this.addigitalMgit.otherPageViewed();
	            //this.googleRemarketing.searchPageView();
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {
	            //this.googleRemarketingTag.otherPageViewed();
	            this.whereElephantCpa.otherPageView(this.data);
	
	            //this.mailru.otherPageView();
	            //this.mailrunew.otherPageView();
	            //this.addigitalMgit.otherPageViewed();
	        }
	    }, {
	        key: 'notFoundPageViewed',
	        value: function notFoundPageViewed() {
	            //this.mailru.otherPageView();
	            //this.mailrunew.otherPageView();
	
	            this.whereElephantCpa.otherPageView(this.data);
	            this.yandexMetrika.notFountPage();
	        }
	    }, {
	        key: 'userRegisteredMain',
	        value: function userRegisteredMain(user) {
	            this.dataLayer.push({ 'event': 'Registration_Done' });
	
	            //this.mindbox.userRegistered(user);
	            //this.facebook.completeRegistration();
	        }
	    }, {
	        key: 'userAuthorizedMain',
	        value: function userAuthorizedMain(user) {
	            this.yandexMetrika.userAuthorized(user);
	
	            //this.flocktory.updateCart(this.data.basket);
	            //this.mindbox.userAuthorized(user);
	        }
	    }, {
	        key: 'userUpdatedProfilePersonal',
	        value: function userUpdatedProfilePersonal(user) {
	            //this.mindbox.userUpdated(user);
	        }
	    }, {
	        key: 'subscriptionChangeClicked',
	        value: function subscriptionChangeClicked() {
	            this.dataLayer.push({ 'event': 'Subscription_Button' });
	        }
	    }, {
	        key: 'subscriptionChanged',
	        value: function subscriptionChanged(user) {
	            this.dataLayer.push({ 'event': 'Subscription_Done' });
	            this.retailrocket.subscription(user.email);
	
	            /*if (this.data.route == 'index') {
	                this.userSubscribedMainpage(subscription);
	            }
	            if (this.data.route == 'personal_account') {
	                this.userSubscribedProfilePersonal(subscription);
	            }*/
	            //this.mindbox.userChangedSubscription(user);
	            //this.facebook.newsletterSubscription();
	        }
	    }, {
	        key: 'subscriptionChangedPopup',
	        value: function subscriptionChangedPopup(user) {
	            this.dataLayer.push({ 'event': 'Subscription_Done' });
	            this.retailrocket.subscriptionPopup(user.email);
	        }
	    }, {
	        key: 'subscriptionPopupForms',
	        value: function subscriptionPopupForms(email) {
	            this.retailrocket.subscription(email);
	        }
	    }, {
	        key: 'userSubscribedProfilePersonal',
	        value: function userSubscribedProfilePersonal(subscription) {
	            if ((false)()) {
	                //console.log(subscription);
	            }
	        }
	    }, {
	        key: 'userSubscribedMainpage',
	        value: function userSubscribedMainpage(subscription) {
	            if ((false)()) {
	                //console.log(subscription);
	            }
	        }
	    }, {
	        key: 'basketItemAddClicked',
	        value: function basketItemAddClicked() {
	            this.dataLayer.push({ 'event': 'Add2Cart_Button' });
	        }
	    }, {
	        key: 'basketItemAdded',
	        value: function basketItemAdded(product) {
	            this.dataLayer.basketItemAdd(product);
	            this.retailrocket.addToCart(product);
	            this.vkAdsPixel.basketItemAdd(product);
	            this.mindboxOperation.setCart();
	            //this.flocktory.addToCart(product);
	            //this.addigital.addToCart(product);
	            //this.mindbox.basketItemAdded(product);
	            //this.facebook.addToCart(product);
	        }
	    }, {
	        key: 'basketItemUpdated',
	        value: function basketItemUpdated(product) {
	            console.log(product);
	
	            //console.log('basketItemUpdated');
	            //console.log(product);
	            //this.mindbox.basketItemUpdated(product);
	        }
	    }, {
	        key: 'basketItemDeleted',
	        value: function basketItemDeleted(product) {
	            this.mindboxOperation.setCart();
	            //this.flocktory.removeFromCart(product);
	        }
	    }, {
	        key: 'basketUpdate',
	        value: function basketUpdate(basketItems) {
	            this.mindboxOperation.setCart();
	            //this.flocktory.updateCart(basketItems);
	        }
	    }, {
	        key: 'basketPageOpenCouponFormButtonClicked',
	        value: function basketPageOpenCouponFormButtonClicked() {
	            this.dataLayer.push({ 'event': 'coupon_link' });
	        }
	    }, {
	        key: 'basketPageCouponConfirmClicked',
	        value: function basketPageCouponConfirmClicked() {
	            this.dataLayer.push({ 'event': 'coupon_button' });
	        }
	    }, {
	        key: 'basketPageCouponApplied',
	        value: function basketPageCouponApplied() {
	            this.dataLayer.push({ 'event': 'coupon_Done' });
	        }
	
	        /*
	        Этих событий нет на сайте сейчас
	        basketPageContinueButtonClicked() {
	            this.dataLayer.push({'event': 'basket_continue'});
	        }
	         basketPageRefreshButtonClicked() {
	            this.dataLayer.push({'event': 'basket_refresh'});
	        }*/
	
	    }, {
	        key: 'basketPageOrderButtonClicked',
	        value: function basketPageOrderButtonClicked() {
	            this.dataLayer.push({ 'event': 'basket_order' });
	        }
	    }, {
	        key: 'oneClickPopupOpened',
	        value: function oneClickPopupOpened(productId) {
	            this.dataLayer.push({ 'event': 'oneClick_buy_Button' });
	            this.dataLayer.push({ 'event': 'PMfrmOneClick' });
	
	            if (productId) {
	                this.retailrocket.oneClick(productId);
	            }
	        }
	    }, {
	        key: 'orderPageContactsTabClicked',
	        value: function orderPageContactsTabClicked() {
	            this.dataLayer.push({ 'event': 'contact_login' });
	        }
	    }, {
	        key: 'orderPageReload',
	        value: function orderPageReload() {
	            this.dataLayer.orderPageReload(this.data.basket);
	        }
	    }, {
	        key: 'orderPageOneClickOrderTabClicked',
	        value: function orderPageOneClickOrderTabClicked() {
	            this.dataLayer.push({ 'event': 'contact_1clickBuy' });
	        }
	    }, {
	        key: 'orderPageConfirmButtonClicked',
	        value: function orderPageConfirmButtonClicked() {
	            this.dataLayer.push({ 'event': 'confirm_order' });
	        }
	    }, {
	        key: 'orderPageRegisterTabClicked',
	        value: function orderPageRegisterTabClicked() {
	            this.dataLayer.push({ 'event': 'contact_registration' });
	        }
	    }, {
	        key: 'orderPageLoyalityCardValidated',
	        value: function orderPageLoyalityCardValidated(card) {
	            this.dataLayer.orderPageLoyalityCardValidtion(card);
	        }
	    }, {
	        key: 'userSubmittedRegistration',
	        value: function userSubmittedRegistration() {
	            this.dataLayer.push({ 'event': 'contact_registration_continue' });
	        }
	    }, {
	        key: 'userSubmittedAuthorization',
	        value: function userSubmittedAuthorization() {
	            this.dataLayer.push({ 'event': 'contact_login_continue' });
	        }
	    }, {
	        key: 'orderPageOneClickOrderButtonClicked',
	        value: function orderPageOneClickOrderButtonClicked() {
	            this.dataLayer.push({ 'event': 'contact_1clickBuy_continue' });
	            //this.facebook.buyOneClick();
	        }
	    }, {
	        key: 'productSubscribed',
	        value: function productSubscribed(product, user) {
	            //this.mindbox.productSubscribed(product, user);
	        }
	    }, {
	        key: 'callbackFormOpened',
	        value: function callbackFormOpened() {
	            this.dataLayer.push({ 'event': 'backcall' });
	            this.dataLayer.push({ 'event': 'PMbtnCallMe' });
	        }
	    }, {
	        key: 'callbackFormSended',
	        value: function callbackFormSended() {
	            this.dataLayer.push({ 'event': 'backcall_sent' });
	            this.dataLayer.push({ 'event': 'PMfrmCallMe' });
	            //this.facebook.requestCallBack();
	        }
	    }, {
	        key: 'onlineChatOpened',
	        value: function onlineChatOpened() {
	            this.dataLayer.push({ 'event': 'online_consultant' });
	        }
	    }, {
	        key: 'onlineChatMessageSended',
	        value: function onlineChatMessageSended() {
	            this.dataLayer.push({ 'event': 'online_consultant_button' });
	        }
	    }, {
	        key: 'productDescriptionTabOpened',
	        value: function productDescriptionTabOpened() {
	            this.dataLayer.push({ 'event': 'description_tab' });
	        }
	    }, {
	        key: 'productAccessoriesTabOpened',
	        value: function productAccessoriesTabOpened() {
	            this.dataLayer.push({ 'event': 'accessories_tab' });
	        }
	    }, {
	        key: 'productReviewsTabOpened',
	        value: function productReviewsTabOpened() {
	            this.dataLayer.push({ 'event': 'reviews_tab' });
	        }
	    }, {
	        key: 'productFaqTabOpened',
	        value: function productFaqTabOpened() {
	            this.dataLayer.push({ 'event': 'faq_tab' });
	        }
	    }, {
	        key: 'productAnalogsTabOpened',
	        value: function productAnalogsTabOpened() {
	            this.dataLayer.push({ 'event': 'analogues_tab' });
	        }
	    }, {
	        key: 'shopsMapOpened',
	        value: function shopsMapOpened() {
	            this.dataLayer.push({ 'event': 'offline_map' });
	        }
	    }, {
	        key: 'clickButtonApplySmartFilter',
	        value: function clickButtonApplySmartFilter() {
	            this.dataLayer.push({ 'event': 'PMbtnFilter' });
	            //this.facebook.applyingFilter();
	        }
	    }, {
	        key: 'tooltipProduct',
	        value: function tooltipProduct(type) {
	            if (type) {
	                var eventName = void 0;
	                switch (true) {
	                    case type === 'delivery':
	                        eventName = 'PMbtnDelivery';
	                        break;
	                    case type === 'cards':
	                        eventName = 'PMbtnBonus';
	                        break;
	                }
	
	                this.dataLayer.push({ 'event': eventName });
	            }
	        }
	    }, {
	        key: 'reviewsAdd',
	        value: function reviewsAdd() {
	            this.dataLayer.push({ 'event': 'PMfrmComment' });
	            //this.facebook.addReview();
	        }
	    }, {
	        key: 'questionsAdd',
	        value: function questionsAdd() {
	            this.dataLayer.push({ 'event': 'PMfrmAsk' });
	            //this.facebook.addQuestion();
	        }
	    }, {
	        key: 'productNotificationAdd',
	        value: function productNotificationAdd(dataAnalytics) {
	            this.dataLayer.push({ 'event': 'PMfrmNotice' });
	            this.retailrocket.subscribeOnItemBackInStock(dataAnalytics.user.email, dataAnalytics.product.id);
	        }
	    }, {
	        key: 'selectedCity',
	        value: function selectedCity(cityName) {
	            this.dataLayer.push({
	                'event': 'PMbtnCity',
	                'pmParam1': cityName.replace(/&quot;/g, '')
	            });
	        }
	    }, {
	        key: 'clickPointYandexMap',
	        value: function clickPointYandexMap(shopName) {
	            this.dataLayer.push({
	                'event': 'PMbtnCityItem',
	                'pmParam1': shopName.replace(/&quot;/g, '')
	            });
	
	            //this.facebook.selectedShop();
	        }
	    }, {
	        key: 'clickPhoneBox',
	        value: function clickPhoneBox() {
	            this.dataLayer.push({ 'event': 'PMbtnTel' });
	        }
	    }, {
	        key: 'clickSocialNetwork',
	        value: function clickSocialNetwork() {
	            //this.facebook.clickSocialNetwork();
	        }
	    }]);

	    return Tracker;
	}();

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RetailRocket = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webpack = __webpack_require__(133);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RetailRocket = exports.RetailRocket = function () {
	    function RetailRocket() {
	        _classCallCheck(this, RetailRocket);
	    }
	
	    _createClass(RetailRocket, [{
	        key: 'track',
	        value: function track(callback) {
	            (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
	                try {
	                    callback();
	                } catch (e) {
	                    if (_webpack.isDevelopment) {
	                        console.log(e);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'viewContentProduct',
	        value: function viewContentProduct(product) {
	            var callback = void 0;
	            if (product.is_offers) {
	                callback = function callback() {
	                    rrApi.groupView(product.offers_id);
	                };
	            } else {
	                callback = function callback() {
	                    rrApi.view(product.id);
	                };
	            }
	
	            this.track(callback);
	        }
	
	        /**
	         * @param categoryCode
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'viewContentCategory',
	        value: function viewContentCategory(category) {
	            if (RetailRocket.isCategorySendTrack(category.code)) {
	                this.track(function () {
	                    rrApi.categoryView(category.id);
	                });
	            }
	        }
	    }, {
	        key: 'subscription',
	        value: function subscription(email) {
	            this.track(function () {
	                rrApi.welcomeSequence(email);
	            });
	        }
	    }, {
	        key: 'subscriptionPopup',
	        value: function subscriptionPopup(email) {
	            this.track(function () {
	                rrApi.welcomeSequence(email);
	            });
	        }
	    }, {
	        key: 'oneClick',
	        value: function oneClick(productId) {
	            this.track(function () {
	                rrApi.addToBasket(productId);
	            });
	        }
	    }, {
	        key: 'addToCart',
	        value: function addToCart(product) {
	            this.track(function () {
	                rrApi.addToBasket(product.id);
	            });
	        }
	    }, {
	        key: 'orderTransaction',
	        value: function orderTransaction(order, basket) {
	            var params = {
	                transaction: order.id,
	                items: this.formatBasket(basket)
	            };
	            this.track(function () {
	                rrApi.order(params);
	            });
	        }
	    }, {
	        key: 'productAddToFavorite',
	        value: function productAddToFavorite(params) {
	            this.subscribeOnPriceDrop(params.email, [params.product]);
	        }
	    }, {
	        key: 'formatBasket',
	        value: function formatBasket(basket) {
	            return basket.map(function (basketItem) {
	                return RetailRocket.formatBasketItem(basketItem);
	            });
	        }
	    }, {
	        key: 'setCustomer',
	        value: function setCustomer(user) {
	            if (!user.authorized) {
	                return;
	            }
	
	            var phone = '7' + user['phone'];
	            if (user.phone_format) {
	                phone = user.phone_format;
	            }
	
	            this.track(function () {
	                rrApi.setCustomer({
	                    customerId: user['user_id'],
	                    email: user['email'],
	                    phone: phone
	                });
	            });
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            this.track(function () {
	                rrApi.search('search_phrase');
	            });
	        }
	
	        /**
	         * "Подписка на снижение цены"
	         * @example rrApi.subscribeOnPriceDrop("null@gmail.com", [{id:3,price:3.9},{id:4,price:1.9}]);
	         * @param email
	         * @param arrayParams
	         */
	
	    }, {
	        key: 'subscribeOnPriceDrop',
	        value: function subscribeOnPriceDrop(email, arrayParams) {
	            this.track(function () {
	                rrApi.subscribeOnPriceDrop(email, arrayParams);
	            });
	            this.logger('subscribeOnPriceDrop', [email, arrayParams]);
	        }
	
	        /**
	         * Письмо с альтернативами отсутствующему товару
	         * @param email
	         * @param productId
	         */
	
	    }, {
	        key: 'subscribeOnItemBackInStock',
	        value: function subscribeOnItemBackInStock(email, productId) {
	            this.track(function () {
	                rrApi.subscribeOnItemBackInStock(email, productId);
	            });
	            this.logger('subscribeOnItemBackInStock', [email, productId]);
	        }
	    }, {
	        key: 'logger',
	        value: function logger(methodName, params) {
	            if (_webpack.isDevelopment) {
	                console.log(methodName);
	                console.log(params);
	            }
	        }
	    }], [{
	        key: 'isCategorySendTrack',
	        value: function isCategorySendTrack(categoryCode) {
	            var excludeCategoriesCode = ['podarki', 'podarki-bossu', 'podarki-dlya-muzhchin', 'dlya-kolleg', 'dlya-podrug', 'dlya-mamy', 'dlya-lyubimoy', 'rasprodazha', 'povrezhdennaya-upakovka'];
	
	            return excludeCategoriesCode.indexOf(categoryCode) === -1;
	        }
	    }, {
	        key: 'formatBasketItem',
	        value: function formatBasketItem(basketItem) {
	            return {
	                id: basketItem.offer_id || basketItem.id,
	                qnt: parseFloat(basketItem.quantity),
	                price: parseFloat(basketItem.price)
	            };
	        }
	    }]);

	    return RetailRocket;
	}();

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var NODE_ENV = process.env.NODE_ENV || 'development';
	var isDevelopment = NODE_ENV === 'development';
	var isProduction = NODE_ENV === 'production';
	
	module.exports = {
	    NODE_ENV: NODE_ENV,
	    isDevelopment: isDevelopment,
	    isProduction: isProduction
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)))

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 *  Старая интеграция
	 */
	var MindboxTracker = exports.MindboxTracker = function () {
	    function MindboxTracker() {
	        _classCallCheck(this, MindboxTracker);
	    }
	
	    _createClass(MindboxTracker, [{
	        key: 'operationSend',
	        value: function operationSend(operation, data) {
	            if (!window.mindbox) {
	                console.error('Not mindbox');
	                return;
	            }
	
	            window.mindbox("async", {
	                operation: operation,
	                data: data,
	
	                onSuccess: function onSuccess() {
	                    console.info('OK MindboxTracker ' + operation + ': %o', data);
	                },
	                onError: function onError(error) {
	                    console.error('ERROR MindboxTracker: ' + operation + ' ' + error);
	                }
	            });
	        }
	    }, {
	        key: 'categoryView',
	        value: function categoryView(category) {
	            this.operationSend('CategoryView', {
	                "viewProductCategory": {
	                    "productCategory": {
	                        "ids": {
	                            beautyShop: category.id
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'productView',
	        value: function productView(product) {
	            this.operationSend('ProductView', {
	                viewProduct: {
	                    price: product.price,
	                    product: {
	                        ids: {
	                            beautyShop: product.article
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'setCart',
	        value: function setCart(basketData) {
	            this.operationSend('SetCart', basketData);
	        }
	    }, {
	        key: 'setWishList',
	        value: function setWishList(productsData) {
	            this.operationSend('SetWishList', productsData);
	        }
	    }, {
	        key: 'authorization',
	        value: function authorization(phone) {
	            this.operationSend('Authorization', {
	                customer: {
	                    mobilePhone: phone
	                }
	            });
	        }
	    }]);

	    return MindboxTracker;
	}();

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.YandexMetrika = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webpack = __webpack_require__(133);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var YandexMetrika = exports.YandexMetrika = function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                if (typeof window.ym != 'undefined') {
	                    window.ym(911423, code, eventCode);
	                    console.log('YandexMetrika: ' + code + ' - ' + eventCode);
	                } else {
	                    console.log('not ym');
	                }
	            } catch (e) {
	                if (_webpack.isDevelopment) {
	                    console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	                }
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	
	        /**
	         *  вот эта тема не работает, так как яндекс либа не успевала загружаться
	         *  по этому вставили этот метод сразу в сенькю пейд в футер
	         */
	
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }, {
	        key: 'notFountPage',
	        value: function notFountPage() {
	            this.track('reachGoal', 'mn_error_404');
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            var userParams = { userId: user.USER_ID };
	            this.track('userParams', userParams);
	            this.track('params', userParams);
	            this.track('setUserID', user.USER_ID);
	        }
	    }, {
	        key: 'orderAutReg',
	        value: function orderAutReg() {
	            this.track('reachGoal', 'order_aut_reg');
	        }
	    }]);

	    return YandexMetrika;
	}();

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MindboxOperation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mindboxTraker = __webpack_require__(135);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MindboxOperation = exports.MindboxOperation = function () {
	    function MindboxOperation() {
	        _classCallCheck(this, MindboxOperation);
	
	        this.mindboxTracker = new _mindboxTraker.MindboxTracker();
	    }
	
	    _createClass(MindboxOperation, [{
	        key: 'setCart',
	        value: function setCart() {
	            var _self = this;
	            $.ajax({
	                url: '/ajax/action/maximaster:widget.mindbox.operation.basket/getdata/',
	                type: 'GET',
	                success: function success(result) {
	                    if (parseInt(result.code) === 200) {
	                        _self.mindboxTracker.setCart(result.data);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'setWishList',
	        value: function setWishList() {
	
	            var _self = this;
	            $.ajax({
	                url: '/ajax/action/maximaster:widget.mindbox.operation.favorite/getdata/',
	                type: 'GET',
	                success: function success(result) {
	                    if (parseInt(result.code) === 200) {
	                        _self.mindboxTracker.setWishList(result.data);
	                    }
	                }
	            });
	        }
	    }]);

	    return MindboxOperation;
	}();

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dataLayerInited = false;
	
	var DataLayerTracker = exports.DataLayerTracker = function () {
	    function DataLayerTracker(data) {
	        _classCallCheck(this, DataLayerTracker);
	
	        this.dataLayer = this.init(data);
	    }
	
	    /**
	     * Инициализируем начальный dataLayer
	     * @param data
	     * @returns {*|Array}
	     */
	
	
	    _createClass(DataLayerTracker, [{
	        key: 'init',
	        value: function init(data) {
	            window.dataLayer = window.dataLayer || [];
	            if (dataLayerInited) {
	                return window.dataLayer;
	            }
	
	            var initialLayer = {
	                isLogged: data.user.authorized
	            };
	
	            if (initialLayer.isLogged) {
	                initialLayer.user = {
	                    birthdate: data.user.born_at ? data.user.born_at.short : 'unknown',
	                    gender: data.user.gender ? data.user.gender : 'unknownn',
	                    regDate: data.user.registered_at.short
	                };
	            }
	
	            switch (data.route) {
	                case 'index':
	                    initialLayer.pagetype = 'main';
	                    break;
	                case 'products':
	                    initialLayer.pagetype = 'catalog';
	                    break;
	                case 'product':
	                    initialLayer.pagetype = 'product';
	                    break;
	                case 'cart':
	                    initialLayer.pagetype = 'basket';
	                    break;
	                case 'order':
	                    initialLayer.pagetype = 'order';
	                    break;
	                case 'order.thankyoupage':
	                    initialLayer.pagetype = 'confirmation';
	                    break;
	                case '404':
	                    initialLayer.pagetype = '404';
	                    break;
	                default:
	                    initialLayer.pagetype = 'other';
	                    break;
	            }
	
	            window.dataLayer.push(initialLayer);
	
	            dataLayerInited = true;
	            return window.dataLayer;
	        }
	    }, {
	        key: 'push',
	        value: function push(layer) {
	            this.dataLayer.push(layer);
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView(products) {
	
	            // #18588 Событие используется для Criteo счетчика. Туда нужно передавать только три первых товара из списка
	            var productIds = products.map(function (product) {
	                return product.id;
	            });
	
	            this.push({
	                'event': 'viewList',
	                'item': productIds.slice(0, 3)
	            });
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(product) {
	
	            // this.push({
	            //     event: 'ecommerceDetail',
	            //     ecommerce: {
	            //         detail: {
	            //             'actionField' : {
	            //                 'list' : localStorage.getItem('analitics_product_list')
	            //             },
	            //             products: {
	            //                 name: product.name,
	            //                 id: product.id,
	            //                 price: parseFloat(product.price),
	            //                 brand: product.vendor,
	            //                 category: product.category,
	            //             }
	            //         }
	            //     }
	            // });
	
	            this.push({
	                event: 'productDetails',
	                ecommerce: {
	                    detail: {
	                        products: {
	                            name: product.name,
	                            id: product.id,
	                            price: parseFloat(product.price),
	                            brand: product.vendor,
	                            category: product.category,
	                            variant: ''
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'basketItemAdd',
	        value: function basketItemAdd(product) {
	            this.push({
	                'event': 'addToCart',
	                'ecommerce': {
	                    'add': {
	                        'products': collectBasketItems([product])
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(basket) {
	            this.push({
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': { 'step': 1 },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	
	            this.push({
	                'event': 'ecommerceCheckout',
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': { 'step': 1 },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView(basket) {
	            this.push({
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': { 'step': 2 },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	
	            this.push({
	                'event': 'ecommerceCheckout',
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': { 'step': 2 },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'orderPageReload',
	        value: function orderPageReload(basket) {
	            this.push({ 'ecommerce': {
	                    'checkout': {
	                        'actionField': { 'step': 3 },
	                        'products': collectBasketItems(basket)
	                    }
	                } });
	
	            this.push({
	                'event': 'ecommerceCheckout',
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': { 'step': 3 },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'orderPageLoyalityCardValidtion',
	        value: function orderPageLoyalityCardValidtion(card) {
	            this.push({
	                'event': 'checkoutOption',
	                'ecommerce': {
	                    'checkout_option': {
	                        'actionField': { 'step': 2, 'option': 'подтвердил пин код бонусной карты' },
	                        'card1': card.number,
	                        'card2': card.pin
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'orderThankyouPageView',
	        value: function orderThankyouPageView(order, basket) {
	            this.push({
	                'event': 'Transaction',
	                'ecommerce': {
	                    'purchase': {
	                        'actionField': {
	                            id: order.id,
	                            affiliation: window.location.host,
	                            revenue: order.price,
	                            tax: order.tax,
	                            shipping: order.delivery_price,
	                            coupon: order.coupon
	                        },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	
	            this.push({ ecommerceGA4: null });
	            this.push({
	                event: 'purchaseGA4',
	                ecommerceGA4: {
	                    transaction_id: order.id,
	                    value: order.price,
	                    coupon: order.coupon,
	                    items: collectBasketItemsGa4(basket)
	                }
	            });
	        }
	    }]);
	
	    return DataLayerTracker;
	}();
	
	var collectBasketItems = function collectBasketItems(basket) {
	    var items = [];
	    basket.forEach(function (basketItem) {
	        items.push(formatBasketItem(basketItem));
	    });
	    return items;
	};
	var formatBasketItem = function formatBasketItem(product) {
	    if (!product) {
	        return {};
	    }
	
	    return {
	        name: product.name,
	        id: product.id,
	        price: product.price,
	        brand: product.vendor,
	        category: product.category,
	        variant: '',
	        quantity: product.quantity
	    };
	};
	
	var formatBasketItemGa4 = function formatBasketItemGa4(product) {
	
	    if (!product) {
	        return {};
	    }
	
	    return {
	        item_name: product.name,
	        item_id: product.id,
	        price: product.price,
	        item_brand: product.vendor,
	        item_category: product.category,
	        quantity: product.quantity
	    };
	};
	var collectBasketItemsGa4 = function collectBasketItemsGa4(basket) {
	    var items = [];
	    basket.forEach(function (basketItem) {
	        items.push(formatBasketItemGa4(basketItem));
	    });
	    return items;
	};

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdmitAdRetargetingTracker = exports.AdmitAdRetargetingTracker = function () {
	    function AdmitAdRetargetingTracker() {
	        _classCallCheck(this, AdmitAdRetargetingTracker);
	    }
	
	    _createClass(AdmitAdRetargetingTracker, null, [{
	        key: 'init',
	        value: function init() {
	            window._retag = window._retag || [];
	            return window._retag;
	        }
	    }, {
	        key: 'registerPageView',
	        value: function registerPageView() {
	            window._retag_data = {};
	            window._retag.push({ code: '9ce888632e' });
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            window._retag.push({ code: '9ce8886333', level: 0 });
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView(category) {
	            window.ad_category = category.id;
	            window._retag.push({ code: '9ce8886332', level: 1 });
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(product) {
	            window.ad_product = {
	                id: product.id,
	                vendor: product.vendor,
	                price: product.price,
	                url: window.location.origin + product.url,
	                picture: window.location.origin + product.picture,
	                name: product.name,
	                category: product.category
	            };
	            window._retag.push({ code: '9ce8886331', level: 2 });
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(basket) {
	            window.ad_products = collectBasketItems(basket);
	            window._retag.push({ code: '9ce8886330', level: 3 });
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView() {
	            AdmitAdRetargetingTracker.registerPageView();
	        }
	    }, {
	        key: 'orderThankyouPageView',
	        value: function orderThankyouPageView(order, basket) {
	            window.ad_order = order.id;
	            window.ad_amount = order.price;
	            window.ad_products = collectBasketItems(basket);
	            window._retag.push({ code: '9ce888632f', level: 4 });
	        }
	    }]);
	
	    return AdmitAdRetargetingTracker;
	}();
	
	var collectBasketItems = function collectBasketItems(basket) {
	    var items = [];
	    basket.forEach(function (basketItem) {
	        items.push({
	            id: basketItem.id,
	            number: basketItem.quantity
	        });
	    });
	    return items;
	};

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdmitAdV2Tracker = exports.AdmitAdV2Tracker = function () {
	    function AdmitAdV2Tracker() {
	        _classCallCheck(this, AdmitAdV2Tracker);
	    }
	
	    _createClass(AdmitAdV2Tracker, null, [{
	        key: 'init',
	        value: function init() {
	            window.ADMITAD = window.ADMITAD || {};
	            window.ADMITAD.Invoice = window.ADMITAD.Invoice || {};
	            //window.ADMITAD.Invoice.broker = 'adm';
	        }
	    }, {
	        key: 'orderThankyouPageView',
	        value: function orderThankyouPageView(order, basket, user) {
	            //if (getCookie('utm_source') !== 'AdmitAd') {
	            //    return;
	            //}
	
	            var orderedItem = AdmitAdV2Tracker.orderPush(basket);
	            window.ADMITAD.Invoice.referencesOrder = window.ADMITAD.Invoice.referencesOrder || [];
	            window.ADMITAD.Invoice.referencesOrder.push({
	                orderNumber: order.id,
	                orderedItem: orderedItem
	            });
	            window.ADMITAD.Invoice.accountId = user.id;
	            //window.ADMITAD.Invoice.category = (user.is_new_user_ecommerce) ? '8' : '7';
	            window.ADMITAD.Invoice.category = '9';
	            if (false) {
	                console.log({
	                    'track': AdmitAdV2Tracker.name,
	                    'data': window.ADMITAD,
	                    'user': user,
	                    'order': order
	                });
	            }
	        }
	    }, {
	        key: 'orderPush',
	        value: function orderPush(basket) {
	            var orderedItem = [];
	            basket.forEach(function (basketItem) {
	                orderedItem.push({
	                    Product: {
	                        productID: basketItem.id,
	                        category: basketItem.admitad.tariff_code,
	                        price: basketItem.price,
	                        priceCurrency: basketItem.currency
	                    },
	                    orderQuantity: basketItem.quantity,
	                    additionalType: 'sale'
	                });
	            });
	
	            return orderedItem;
	        }
	    }]);
	
	    return AdmitAdV2Tracker;
	}();
	
	var getCookie = function getCookie(name) {
	    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
	    return matches ? decodeURIComponent(matches[1]) : undefined;
	};

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Vk = exports.Vk = function () {
	    function Vk() {
	        _classCallCheck(this, Vk);
	    }
	
	    _createClass(Vk, [{
	        key: 'eventInit',
	        value: function eventInit(eventName, params) {
	            window.vkAsyncInit = function () {
	                VK.Retargeting.Init('VK-RTRG-355888-7PGvs');
	                VK.Retargeting.ProductEvent(3440, eventName, params);
	            };
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(product) {
	            this.eventInit('view_product', {
	                'products': [{ id: product.id }],
	                'total_price': product.price
	            });
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(basket) {
	            var ids = [],
	                totalPrice = 0.0;
	
	            basket.forEach(function (product) {
	                ids.push({ 'id': product.id });
	                totalPrice += parseFloat(product.price) * product.quantity;
	            });
	            this.eventInit('add_to_cart', {
	                'products': ids,
	                'total_price': totalPrice
	            });
	        }
	    }, {
	        key: 'orderThankyouPageView',
	        value: function orderThankyouPageView(basket) {
	            var ids = [],
	                totalPrice = 0.0;
	
	            basket.forEach(function (product) {
	                ids.push({ 'id': product.id });
	                totalPrice += parseFloat(product.price) * product.quantity;
	            });
	
	            this.eventInit('purchase', {
	                'products': ids,
	                'total_price': totalPrice
	            });
	        }
	    }]);

	    return Vk;
	}();

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WhereElephantCpa = exports.WhereElephantCpa = function () {
	    function WhereElephantCpa() {
	        _classCallCheck(this, WhereElephantCpa);
	
	        this.init();
	    }
	
	    _createClass(WhereElephantCpa, [{
	        key: 'init',
	        value: function init() {
	            window.gdeslon_q = window.gdeslon_q || [];
	            return window.gdeslon_q;
	        }
	    }, {
	        key: 'push',
	        value: function push() {
	            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            params.merchant_id = 93424;
	            window.gdeslon_q.push(params);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.push({
	                'page_type': 'main',
	                'user_id': data.user.email
	            });
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var productResult = [];
	            var products = data.products;
	            var count = products.length;
	            for (var i = 0; i < count; i++) {
	                var product = products[i];
	                var params = {};
	                params.id = parseInt(product.id);
	                params.price = product.price;
	                params.quantity = 1;
	                productResult.push(params);
	            }
	
	            this.push({
	                'page_type': 'list',
	                'user_id': data.user.email,
	                'category_id': data.category.id,
	                'products': productResult
	            });
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.push({
	                'page_type': 'card',
	                'user_id': data.user.email
	            });
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.push({
	                'page_type': 'basket',
	                'user_id': data.user.email,
	                'products': data.basket
	            });
	        }
	    }, {
	        key: 'otherPageView',
	        value: function otherPageView(data) {
	            this.push({
	                'page_type': 'basket',
	                'user_id': data.user.email
	            });
	        }
	    }]);

	    return WhereElephantCpa;
	}();

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VkAdsPixel = exports.VkAdsPixel = function () {
	    function VkAdsPixel() {
	        _classCallCheck(this, VkAdsPixel);
	
	        this.init();
	    }
	
	    _createClass(VkAdsPixel, [{
	        key: 'init',
	        value: function init() {
	            window._tmr = window._tmr || [];
	            return window._tmr;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window._tmr.push(query);
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(product) {
	            this.push(_extends(this.getQueryTemplate(), {
	                value: parseFloat(product.price),
	                goal: 'viewProduct',
	                params: { product_id: product.id }
	            }));
	        }
	    }, {
	        key: 'orderThankyouPageView',
	        value: function orderThankyouPageView(basket) {
	            var ids = [];
	            basket.forEach(function (product) {
	                ids.push(product.id);
	            });
	            this.push(_extends(this.getQueryTemplate(), {
	                goal: 'purchase',
	                value: 'VALUE',
	                params: { product_id: ids }
	            }));
	        }
	    }, {
	        key: 'basketItemAdd',
	        value: function basketItemAdd(product) {
	            this.push(_extends(this.getQueryTemplate(), {
	                value: parseFloat(product.price),
	                goal: 'addToCart',
	                params: { product_id: product.id }
	            }));
	        }
	    }, {
	        key: 'productAddToFavorite',
	        value: function productAddToFavorite(product) {
	            this.push(_extends(this.getQueryTemplate(), {
	                value: parseFloat(product.price),
	                goal: 'addToWishlist',
	                params: { product_id: product.id }
	            }));
	        }
	    }, {
	        key: 'getQueryTemplate',
	        value: function getQueryTemplate() {
	            return {
	                id: '3464578',
	                type: 'reachGoal'
	            };
	        }
	    }]);

	    return VkAdsPixel;
	}();

/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 *  Интеграция с сервисом
	 *  https://support.advcake.com/docs/advdocs/integration/pixel-ecom-beauty-shop.html#js
	 */
	var AdvCake = exports.AdvCake = function () {
	    function AdvCake() {
	        _classCallCheck(this, AdvCake);
	
	        this.init();
	    }
	
	    _createClass(AdvCake, [{
	        key: 'init',
	        value: function init() {
	            window.advcake_data = window.advcake_data || [];
	            return window.advcake_data;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window.advcake_data.push(query);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.push({
	                pageType: 1,
	                user: {
	                    email: data.user.authorized ? data.user.email_md5 : ''
	                }
	            });
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	            var categoryParams = {};
	            if (data.product.category_params) {
	                categoryParams = {
	                    id: parseInt(data.product.category_params.ID),
	                    name: data.product.category_params.NAME
	                };
	            }
	
	            this.push({
	                pageType: 2,
	                user: {
	                    email: data.user.authorized ? data.user.email_md5 : ''
	                },
	                currentCategory: categoryParams,
	                currentProduct: {
	                    id: parseInt(data.product.id),
	                    name: data.product.name,
	                    price: parseFloat(data.product.price)
	                },
	                basketProducts: this.formatBasket(data.basket)
	            });
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed(data) {
	            this.push({
	                pageType: 4,
	                user: {
	                    email: data.user.authorized ? data.user.email_md5 : ''
	                },
	                basketProducts: this.formatBasket(data.basket, true)
	            });
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.push({
	                pageType: 3,
	                user: {
	                    email: data.user.authorized ? data.user.email_md5 : ''
	                },
	                currentCategory: {
	                    id: parseInt(data.category.id),
	                    name: data.category.name
	                },
	                products: this.formatProducts(data.products),
	                basketProducts: this.formatBasket(data.basket)
	            });
	        }
	    }, {
	        key: 'orderThankyouPageViewed',
	        value: function orderThankyouPageViewed(data) {
	            this.push({
	                pageType: 6,
	                user: {
	                    email: data.user.authorized ? data.user.email_md5 : '',
	                    type: ''
	                },
	                basketProducts: this.formatBasket(data.basket, true),
	                orderInfo: {
	                    id: data.order.id,
	                    totalPrice: parseFloat(data.order.product_price),
	                    coupon: data.order.coupon
	                }
	            });
	        }
	    }, {
	        key: 'pageOrderView',
	        value: function pageOrderView(data) {
	            this.push({
	                pageType: 5,
	                user: {
	                    email: data.user.authorized ? data.user.email_md5 : '',
	                    type: ''
	                },
	                basketProducts: this.formatBasket(data.basket, true)
	            });
	        }
	    }, {
	        key: 'formatProducts',
	        value: function formatProducts(products) {
	            return products.map(function (productItem) {
	                return AdvCake.formatProductsItem(productItem);
	            });
	        }
	    }, {
	        key: 'formatBasket',
	        value: function formatBasket(basket) {
	            var isBasketPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            return basket.map(function (basketItem) {
	                return AdvCake.formatBasketItem(basketItem, isBasketPage);
	            });
	        }
	    }], [{
	        key: 'formatProductsItem',
	        value: function formatProductsItem(productItem) {
	            return {
	                id: parseInt(productItem.id),
	                name: productItem.name,
	                price: parseFloat(productItem.price)
	            };
	        }
	    }, {
	        key: 'formatBasketItem',
	        value: function formatBasketItem(basketItem) {
	            var isBasketPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	
	            // eslint-disable-next-line no-unused-vars
	            var categoryId = void 0,
	                categoryName = void 0;
	
	            if (!isBasketPage) {
	                categoryId = parseInt(basketItem.section.ID);
	                categoryName = basketItem.section.NAME;
	            }
	            if (isBasketPage) {
	                categoryId = parseInt(basketItem.category_id);
	                categoryName = basketItem.category;
	            }
	
	            return {
	                id: parseInt(basketItem.offer_id) || parseInt(basketItem.id),
	                name: basketItem.name,
	                quantity: parseFloat(basketItem.quantity),
	                price: parseFloat(basketItem.price),
	                categoryId: categoryId,
	                categoryName: categoryName
	            };
	        }
	    }]);

	    return AdvCake;
	}();

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/tracker.5aacecec8a623c34a08a.js